import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faGithub,
  faStrava,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import SelfPic from "./../../assets/images/self_pic.jpg";
import "./home.css";
import { Typography } from "@mui/material";
import { Fade } from "@mui/material";
import PropTypes from "prop-types";

const Home = ({ homeIsVisible }) => {
  Home.propTypes = {
    homeIsVisible: PropTypes.bool,
  };

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(homeIsVisible);
  }, [homeIsVisible]);

  return (
    <Fade in={isVisible} timeout={500}>
      <div className="home-container">
        <div className="home-top-content">
          <div className="home-text">
            <Typography variant="h1">Hello! I&apos;m Antonio. 👋🏽</Typography>
            <Typography variant="h3">Full Stack Software Engineer</Typography>
          </div>
          <div className="home-img">
            <img id="self-pic" src={SelfPic} width="250px" />
          </div>
        </div>

        <div className="home-icons">
          <a
            href="https://www.linkedin.com/in/abfranco/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button linkedin"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a
            href="https://github.com/ABFranco"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button github"
          >
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a
            href="https://www.strava.com/athletes/antoniofranco"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button strava"
          >
            <FontAwesomeIcon icon={faStrava} />
          </a>
          <a
            href="https://www.instagram.com/runwithantonio/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button instagram"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
      </div>
    </Fade>
  );
};

export default Home;
